import type { TimelineLayerInfo } from "./layerHierarchy";
import {
  getKeyframePropertyPath,
  normalizeKeyframePath,
} from "./keyframeHelpers";
import type { KeyframeInfo } from "./keyframeHelpers";

export function buildTimelineKeyframeId(
  layer: TimelineLayerInfo,
  keyframe: Pick<KeyframeInfo, "path">
): string {
  return `${layer.instancePath}::${normalizeKeyframePath(keyframe.path)}`;
}

export function buildTimelineKeyframeDataAttributes(params: {
  id: string;
  layer: TimelineLayerInfo;
  keyframe: KeyframeInfo;
  resolvedTime: number;
  compositionTime: number;
  minTime: number;
  maxTime: number;
}): Record<string, string> {
  const {
    id,
    layer,
    keyframe,
    resolvedTime,
    compositionTime,
    minTime,
    maxTime,
  } = params;

  return {
    "data-keyframe-id": id,
    "data-layer-name": layer.nm,
    "data-layer-uid": layer.uid == null ? "" : String(layer.uid),
    "data-asset-id": layer.assetId ?? "",
    "data-property-path": getKeyframePropertyPath(keyframe.path),
    "data-keyframe-index": String(keyframe.keyframeIndex),
    "data-resolved-time": String(resolvedTime),
    "data-composition-time": String(compositionTime),
    "data-min-time": String(minTime),
    "data-max-time": String(maxTime),
  };
}
